/**
 * Formats vertical as either "K-12" or "Corporate" for use in industry"
 * @param {bool} ExplicitOptIn
 */

/**
 * Converts ExplicitOptIn bool to either "on" or "off"
 * @param {bool} ExplicitOptIn
 */
const deriveExplicitOptIn = (ExplicitOptIn) => (ExplicitOptIn ? "on" : "off");

/**
 * Tries to return the url of the current page
 */
const populateLandingPageURL = () => (typeof window !== "undefined" ? window.location.href : "");

/**
 * Performs some conversions/formatting, and additions to the formdata.
 * [Industry, ExplicitOptIn, LandingPageURL]
 * @param {string} vertical
 * @param {Object} formData all the other form data
 */
export const deriveSubmitData = (vertical, formData) => ({
    ...formData,
    ExplicitOptIn: deriveExplicitOptIn(formData.ExplicitOptIn),
    LandingPageURL: populateLandingPageURL()
});

/**
 * Converts JS object to URL form submission url
 * @param {Object} submitData data to be submitted
 */
export const constructSubmitUrl = (submitData) => {
    const baseUrl = "https://s1294.t.eloqua.com/e/f2?";
    const params = Object.keys(submitData).map((key) => `${key}=${encodeURIComponent(submitData[key])}`);
    return baseUrl + params.join("&");
};

/**
 * Submits email to Bizible. Adapted from Bizible's documentaiton on "AJAX Form
 * Handling"
 * @param {string} email user email
 */
export const submitToBizible = (email) => {
    // Preamble for all API usage.
    /* eslint-disable no-underscore-dangle */
    window.Bizible = window.Bizible || {
        _queue: [],
        Push(o, p) {
            this._queue.push({ type: o, data: p });
        }
    };
    /* eslint-enable no-underscore-dangle */
    // If your site is using Ajax, or you are running a secure site, it is best to send us the data directly.
    window.Bizible.Push("User", {
        eMail: email // required
    });
};
